<template>
  <div class="c-actions-button">
    <template v-if="items.length <= +maxButtonCount">
      <c-button
        v-for="item in items"
        v-bind="{
          ...buttonProps,
          ...item
        }"
        :icon-size="iconSize"
        flat
        v-tooltip.dark="{ ...item?.tooltip, hide: !item?.tooltip }"
        data-testid="item"
        :key="item.label"
        :size="buttonSize"
        @click.stop="$emit(`action:${item.name}`, item.props)"
      />
    </template>

    <c-button
      v-bind="{
        flat: true,
        ...buttonProps
      }"
      v-else-if="!!items.length"
      data-testid="dots"
      icon="dots-menu"
      :size="buttonSize"
      :icon-size="iconSize"
      ref="dots"
      @click.stop="showPopover = !showPopover"
    />

    <c-actions-popover
      v-bind="filteredVue3Listeners"
      v-if="showPopover"
      data-testid="popover"
      class="popover"
      element-spacing="5"
      hide-on-scroll
      ignore-target-click
      :items="items"
      :target="$refs.dots.$el"
      @close="showPopover = false"
      v-on="filteredListeners"
    />
  </div>
</template>

<script>
import { tooltip } from '@convenia/components/directives'
import useVue3Migration from '@convenia/composables/useVue3Migration'
import CButton from '@convenia/components/CButton'
import CActionsPopover from '@convenia/components/CActionsPopover'

export default {
  name: 'CActionsButton',
  directives: { tooltip },
  components: {
    CButton,
    CActionsPopover
  },
  setup (_, ctx) {
    const { componentListeners, isVue2 } = useVue3Migration(ctx)

    return {
      componentListeners,
      isVue2
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: value => value.every(item => item.label && item.icon && item.name),
    },

    maxButtonCount: {
      type: [ String, Number ],
      default: 2,
    },

    buttonSize: {
      type: [ String, Number ],
      default: '40',
    },

    iconSize: {
      type: [ String, Number ],
      default: '20',
    },

    buttonProps: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({ showPopover: false }),

  computed: {
    filteredListeners () {
      const { close, ...listeners } = this.componentListeners
      return listeners
    },
    filteredVue3Listeners () {
      const { onClose, ...otherAttrs } = this.$attrs
      return this.isVue2
        ? {}
        : Object.fromEntries(Object.entries(otherAttrs)
          .filter(([ attrName ]) => attrName.startsWith('onAction:')))
    }
  },
}
</script>

<style lang="scss">
.c-actions-button {
  display: flex;
  flex-flow: row nowrap;

  &:not(:has(.popover)) { gap: 10px; }
}
</style>
